export default __webpack_public_path__ + "static/media/Removed.3313fa75.svg";